<script setup>
import TD from "@/Components/Table/Element.vue";
import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Label from "@/Components/Settings/Label.vue";
import Button from "@/Components/Button.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import Heading from "@/Components/Settings/Heading.vue";

import { Head, useForm, Link } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import { computed } from "vue";
const page_name = "Notdienst";

const props = defineProps({
  emergencies: Array,
});

function repetitionString(repetition) {
  switch (repetition) {
    case "once":
      return "keine";
    case "daily":
      return "Täglich";
    case "weekly":
      return "Wöchentlich";
    case "monthly":
      return "Monatlich";
  }
}

function deleteEmergency(id) {
  Inertia.delete(
    `/emergencyService/${id}`,
    {},
    { preserveState: true, replace: true }
  );
}

const canEdit = Inertia.page.props.auth.can["edit settings"];
const canDelete = Inertia.page.props.auth.can["delete settings"];

const form = useForm({});
</script>
<template>
  <SettingsLayout>
    <!-- <Head title="Stammdaten - Grundeinstellungen" /> -->
    <Head :title="`${page_name} - Grundeinstellungen`" />

    <template #breadcrumb>{{ page_name }}</template>
    <template #controls>
      <HeaderLink href="/" type="close">Schließen</HeaderLink>
    </template>
    <Heading title="Notdienst" />

    <p class="max-w-2xl text-sm text-oteoText mb-9">
      Den Notdienst Ihrer Praxis legen Sie hier fest. Der Notdienst wird in
      Ihrer Kalenderansicht rot markiert, so dass immer klar ersichtlich ist, an
      welchen Tagen Sie Notdienst haben. Sie können den Tag, die Uhrzeit,
      den/die Behandler/in auswählen und eine Telefonnummer für Notfälle
      hinterlegen. Zudem können Sie vorab Wiederholungen bei wiederkehrenden
      Notdiensten definieren.
    </p>

    <Button
      v-if="canEdit"
      href="/einstellungen/notdienst/erstellen"
      class="mb-9"
    >
      Neuen Notdienst anlegen
    </Button>

    <div class="flex flex-col">
      <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 inline-block min-w-full sm:px-6 lg:px-8">
          <div class="overflow-hidden">
            <table class="min-w-full">
              <thead class="bg-white border-b">
                <tr>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Behandler
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Datum
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Zeit
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Wiederholung
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Aktion
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(emergency, index) in emergencies"
                  :key="emergency.id"
                  class="border-b"
                  :class="{ 'bg-gray-100': index % 2 === 0 }"
                >
                  <TD>{{ emergency.practitioner.fullname }}</TD>
                  <TD>{{ emergency.dateString }}</TD>
                  <TD>{{
                    emergency.startString + " - " + emergency.endString + " Uhr"
                  }}</TD>
                  <TD> {{ repetitionString(emergency.repetition) }} </TD>
                  <TD>
                    <div v-if="canEdit" class="flex items-center text-oteo-300">
                      <Link
                        class="mr-4"
                        :href="`notdienst/${emergency.id}/bearbeiten/`"
                      >
                        <i class="las la-angle-right"></i>bearbeiten
                      </Link>
                      <div
                        v-if="canDelete"
                        class="cursor-pointer"
                        @click="deleteEmergency(emergency.id)"
                      >
                        <i class="las la-times"></i>
                        löschen
                      </div>
                    </div>
                  </TD>
                </tr>

                <tr>
                  <TD></TD>
                  <TD></TD>
                  <TD></TD>
                  <TD></TD>
                  <TD>
                    <!-- CAN EDIT!!! -->
                  </TD>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </SettingsLayout>
</template>

